// 2020-05-21export { AlimentoChartComponent } from './alimento-chart.component';